import React from "react";

const ForkLiftLoading = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_12921_75738)">
        <path d="M7.52987 8.46982H3.13771C2.80489 8.46982 2.4857 8.60204 2.25036 8.83738C2.01502 9.07271 1.88281 9.3919 1.88281 9.72472V12.862M1.88281 12.862C1.88281 13.555 2.44465 14.1169 3.13771 14.1169C3.83078 14.1169 4.39262 13.555 4.39262 12.862C4.39262 12.1689 3.83078 11.6071 3.13771 11.6071C2.44465 11.6071 1.88281 12.1689 1.88281 12.862ZM6.90242 12.862C6.90242 13.555 7.46426 14.1169 8.15732 14.1169C8.85039 14.1169 9.41222 13.555 9.41222 12.862C9.41222 12.1689 8.85039 11.6071 8.15732 11.6071C7.46426 11.6071 6.90242 12.1689 6.90242 12.862ZM6.90242 12.862H5.02007M10.0397 2.19531V12.862H13.8044M3.76517 8.46982V5.33257C3.76517 4.64237 4.32987 4.07767 5.02007 4.07767H6.90242L10.0397 7.21492" stroke="#252525" stroke-width="0.941176" stroke-linecap="round" stroke-linejoin="round"/>
        <rect x="11.7675" y="8.00184" width="2.82353" height="2.82353" fill="#252525" stroke="#252525" stroke-width="0.941176"/>
        <rect x="11.7675" y="3.76746" width="2.82353" height="2.82353" fill="#252525" stroke="#252525" stroke-width="0.941176"/>
        <rect x="11.7675" y="-0.466912" width="2.82353" height="2.82353" fill="#252525" stroke="#252525" stroke-width="0.941176"/>
        </g>
        <defs>
        <clipPath id="clip0_12921_75738">
        <rect width="16" height="16" fill="black"/>
        </clipPath>
        </defs>
        </svg>
    );
}

export default ForkLiftLoading
